<template>
    <v-row no-gutters>
        <v-container>
            <div class="d-flex justify-content-center align-center" style="min-height: 70vh;position: relative;">
                <v-img 
                    src="/images/404.png"
                    class="d-flex justify-content-center align-center" style="min-height: 700px;object-fit: cover;"
                    >
                    <div class="text-center">
                   <h2 class="text-h2 font-weight-bold text-404 yellow--text text--darken-3" >404</h2>
                   <h3 class="text-h4 white--text text-not-found">{{$t('page_not_found')}}</h3>
                    <v-btn outlined class=" rounded-pill" dark @click="$router.push({ name: 'welcome' })">Kembali</v-btn>
                </div>
                </v-img>
            </div>
        </v-container>
    </v-row>
</template>
<script>
export default {
    data: () => ({}),
    created() { },
    methods: {

    },
};
</script>
<style>
    .text-404{
        text-shadow: 4px 4px 2px #303030;
    }

    .text-not-found{
        text-shadow: 4px 4px 2px #303030;
    }
</style>